import BreadCrumb, { upcomingEventBg } from "../components/BreadCrumb.jsx"
import UpcomingEvents from "../components/UpcomingEvents.jsx"
import WhyUs from "../components/WhyUs.jsx"
import BenifitsOfPartnership from "../components/BenifitsOfPartnership.jsx"


function UpcomingEventsPage() {

    return (
        <>
            <BreadCrumb 
            backgroundImage={upcomingEventBg}
            title={"Upcoming Events"}
            description={"Stay updated with our latest events and activities."}
            />
            <UpcomingEvents/>
            <WhyUs/>
            <BenifitsOfPartnership/>
        </>
    )
}

export default UpcomingEventsPage